import duasData from '../data/duas.json';

export const fetchDuas = async () => {
  // Return the duas array from the local JSON file
  return duasData.duas;
};
